import NiceModal from '@ebay/nice-modal-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { queryClient } from './libraries/react-query';
import ErrorBoundary from './providers/ErrorBoundary';
import MantineProvider from './providers/Mantine';

export default function Provider() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <MantineProvider>
          <BrowserRouter>
            <NiceModal.Provider>
              <App />
            </NiceModal.Provider>
          </BrowserRouter>
        </MantineProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
